import React, { useState } from 'react';

import PermissionTooltip from '@dashboard/components/PermissionTooltip';
import { type FVerifiedEmailAddressFragment } from '@dashboard/generated/wp/platform';
import { EditOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { usePermission } from '../../hooks';

import FormDialog from './FormDialog';

type Props = {
  model: FVerifiedEmailAddressFragment;
};

export default function EditVerifiedEmailAddressDialog({ model }: Props) {
  const [open, setOpen] = useState(false);
  const permission = usePermission('updateVerifiedEmailAddress');

  if (!permission) {
    return (
      <PermissionTooltip span name="updateVerifiedEmailAddress">
        <IconButton disabled size="small">
          <EditOutlined />
        </IconButton>
      </PermissionTooltip>
    );
  }

  const dialog = open ? <FormDialog model={model} onClose={() => setOpen(false)} /> : null;

  return (
    <>
      <IconButton size="small" onClick={() => setOpen(true)}>
        <EditOutlined fontSize="small" />
      </IconButton>
      {dialog}
    </>
  );
}
